export enum EstateTypeNameEnum {
  "土地" = "土地",
  "分譲地" = "分譲地",
  "新築建売" = "新築建売",
  "中古戸建" = "中古戸建",
  "マンション" = "マンション",
  "事業用" = "事業用"
}
